// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { iconsSharedStyles } from "@eisinc/App/SharedStyles/IconsStyles";
import { headerStyles } from "@eisinc/Overrides/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

headerStyles.pdfButton = {
    css: css`
        ${iconsSharedStyles}
    `,
};

headerStyles.buttonGridItem = {
    css: css`
        justify-content: flex-end;
        align-items: center;
    `,
    width: [2, 2, 2, 6, 6],
};

headerStyles.titleGridItem = {
    width: [10, 10, 10, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

headerStyles.title = {
    variant: "h2",
    as: "h1",
    css: css`
        margin-bottom: 0;
    `,
};

headerStyles.subTitle = {
    variant: "h3",
    as: "h2",
    css: css`
        margin-bottom: 0;
    `,
};

headerStyles.buttonsHiddenContainer = {
    below: "lg",
    css: css`
        width: 100%;
        display: flex;
        justify-content: flex-end;
    `,
};

headerStyles.buttonWrapper = {
    css: css`
        margin-left: 20px;
    `,
};

headerStyles.easyPayButton = {
    typographyProps: {
        color: "text",
        css: css`
            display: flex;
            align-items: center;
            &&& {
                color: ${color("text")};
                &:hover {
                    color: ${color("primary")};
                    text-decoration: underline;
                }
            }
        `,
        ...fontConfig.regular,
        weight: fontConfig.weight.regular,
    },
    css: css`
        ${IconWrapper} {
            opacity: 1;
        }
    `,
};

headerStyles.easyPayButtonWithinOverflowMenu = {
    typographyProps: {
        css: css`
            padding: 0 !important;
            color: ${color("text.main")} !important;
        `,
    },
};

headerStyles.iconStyle = {
    size: 16,
    color: "primary.main",
    css: css`
        margin-right: 5px;
    `,
};

headerStyles.spinnerWrapper = {
    css: css`
        padding: 10px 15px;
    `,
};

headerStyles.spinner = {
    color: "primary.main",
    size: 25,
    css: css`
        margin: 0 auto;
    `,
};
